<script setup>
import { computed, watch } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';
// sutil: seletor de abas por usuario
import { useUISettings } from 'dashboard/composables/useUISettings';
import SutilTabPicker from './SutilTabPicker.vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

// sutil: abas escondidas ficam no ui_settings do usuario.
// Sem preferencia gravada, "Nao atribuidas" nasce escondida -- e a menos util
// aqui (a automacao atribui tudo no ato) e era a que mais espremia a barra.
const { uiSettings } = useUISettings();
const sutilHiddenTabs = computed(
  () => uiSettings.value?.sutil_hidden_tabs ?? ['unassigned']
);
const visibleItems = computed(() => {
  const visiveis = props.items.filter(
    item => !sutilHiddenTabs.value.includes(item.key)
  );
  return visiveis.length ? visiveis : props.items;
});

const activeTabIndex = computed(() => {
  return visibleItems.value.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < visibleItems.value.length) {
    const selectedItem = visibleItems.value[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

// se o usuario esconder justamente a aba ativa, cai na primeira visivel
watch(activeTabIndex, indice => {
  if (indice === -1 && visibleItems.value.length) {
    emit('chatTabChange', visibleItems.value[0].key);
  }
});

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="relative w-full">
    <woot-tabs
      :index="activeTabIndex"
      class="w-full px-3 -mt-1 py-0 pr-11 [&_ul]:p-0"
      @change="onTabChange"
    >
      <woot-tabs-item
        v-for="(item, index) in visibleItems"
        :key="item.key"
        class="text-sm [&_a]:font-medium"
        :index="index"
        :name="item.name"
        :count="item.count"
        is-compact
      />
    </woot-tabs>
    <div class="absolute z-10 -translate-y-1/2 right-2 top-1/2">
      <SutilTabPicker :items="items" />
    </div>
  </div>
</template>
